"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRefusedReason = exports.mangopayKYCDocRefusedReasonType = void 0;
exports.mangopayKYCDocRefusedReasonType = {
    DOCUMENT_UNREADABLE: "Document unreadable - picture is not clear enough, some important parts of the picture are not in the picture or not visible due to light reflection. Documents have to be uploaded in English, Spanish, German, French, Italian, Dutch, or Portuguese. Any other language will be declined as unreadable.",
    DOCUMENT_NOT_ACCEPTED: "Document not accepted - incorrect type of document uploaded. For identity proof, a valid passport is required (a National ID card from countries outside Europe is not accepted by Mangopay).",
    DOCUMENT_HAS_EXPIRED: "Document expired - uploaded document is expired. Passport is expired or registration proof is older than 3 months (it has to be no older than 3 months)",
    DOCUMENT_INCOMPLETE: "Document incomplete - part of the document is missing (you did not upload all the pages), or the document has to be signed and the signature is missing.",
    DOCUMENT_MISSING: "Document missing.",
    DOCUMENT_DO_NOT_MATCH_USER_DATA: "Document does not match user data - incorrect name and/or surname provided. It has to match your passport details (all given names, all surnames, correctly set which is surname and which is given name according to passport).",
    DOCUMENT_DO_NOT_MATCH_ACCOUNT_DATA: "Document does not match account data - incorrect name and/or surname provided. It has to match your passport details (all given names, all surnames, correctly set which is surname and which is given name according to passport).",
    DOCUMENT_FALSIFIED: "Document falsified",
    UNDERAGE_PERSON: "Document belongs to underage person.",
    SPECIFIC_CASE: "Specific case - the document was declined for a different reason. Contact drivers support for more info.",
};
const parseRefusedReason = (kycDocument) => {
    if (!kycDocument.RefusedReasonType) {
        return undefined;
    }
    let reason;
    if (!exports.mangopayKYCDocRefusedReasonType[kycDocument.RefusedReasonType]) {
        reason = "unknown";
    }
    else {
        reason = exports.mangopayKYCDocRefusedReasonType[kycDocument.RefusedReasonType];
    }
    if (kycDocument.RefusedReasonMessage) {
        reason = `${reason} ${kycDocument.RefusedReasonMessage}`;
    }
    return reason;
};
exports.parseRefusedReason = parseRefusedReason;
//# sourceMappingURL=MangopayKYCDocRefusedReasonType.js.map